import { HTMLAttributes, ReactNode } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: "default" | "subtle";
  padding?: "sm" | "md" | "lg";
}

export default function Card({ 
  children, 
  variant = "default", 
  className = "",
  padding = "md",
  ...props
}: CardProps) {
  const baseClasses = "rounded-xl border";
  
  const variantClasses = {
    default: "bg-white border-slate-200 shadow-sm",
    subtle: "bg-slate-50 border-slate-200",
  };

  const paddingClasses = {
    sm: "p-4",
    md: "p-6",
    lg: "p-8",
  };

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${paddingClasses[padding]} ${className}`} {...props}>
      {children}
    </div>
  );
}
